import * as formik from 'formik';
import * as yup from 'yup';

import { Form, Modal } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import AdvancesAPI from '../AdvancesAPI';
import AppButton from '../../../commons/buttons/AppButton';
import AppContainer from '../../../commons/containers/AppContainer';
import AppCurrencyInput from '../../../commons/inputs/AppCurrencyInput';
import AppLinkButton from '../../../commons/buttons/AppLinkButton';
import AppLoading from '../../../commons/AppLoading';
import AppTextAreaInput from '../../../commons/inputs/AppTextAreaInput';
import CalendarInput from '../../../commons/inputs/CalendarInput';
import CompanyAPI from '../../company/CompanyAPI';
import HallAppToast from '../../../commons/HallAppToast';
import { formatDateInEN } from '../../../commons/util/HallAppUtil';
import { useParams } from 'react-router-dom';

const companyAPI = new CompanyAPI();
const advancesAPI = new AdvancesAPI();

const AdvancesModal = ({ show, closeShow, item, callList }) => {

    const [initialValues, setInitialValues] = useState({
        description: '',
    });
    const { employeeId } = useParams();

    const [startDate, setStartDate] = useState(new Date());
    const [transactionDate, setTransactionDate] = useState(null);

    const [value, setValue] = useState(0);

    const [isLoading, setLoading] = useState(false);

    const { Formik } = formik;

    const schema = yup.object().shape({
        description: yup.string().max(100, 'Descrição deve ter no maximo 100 cracteres'),
    });

    useEffect(() => {
        if (item != null && Object.keys(item).length > 0) {
            const dateString = item.advanceDate;
            const [year, month, day] = dateString.split("-");
            const localDate = new Date(year, month - 1, day);
            setStartDate(localDate);
            setTransactionDate(item.advanceDate)

            setInitialValues({
                description: item.description,
                value: item.value
            })
            setValue(item.value)
        }
    }, [item]);


    const createOrUpdate = async (values, { resetForm }) => {

        try {
            setLoading(true)


            const data = {
                ...values,
                value: value,
                date: transactionDate || formatDateInEN(new Date()),
                companyId: companyAPI.getCompanyManagment().id,
                employeeId: employeeId
            }

            if (item.id) {

                await advancesAPI.update(item.id, data);
            } else {
                await advancesAPI.create(data);
            }

            HallAppToast.success();
            resetForm();
            setValue(0)
            if (callList) {
                callList()
            }
            closeShow()
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setLoading(false)
        }
    }

    function handleChangeDate(date) {
        setTransactionDate(date)
    }

    return (
        <>
            <Modal show={show} fullscreen={true} onHide={() => closeShow()}>
                <Modal.Header className='custom-close-button' closeButton>
                    <Modal.Title style={{ textAlign: 'center', fontSize: '15px' }}>
                        ADICIONAR ADIANTAMENTO
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AppContainer>
                        <Formik
                            validationSchema={schema}
                            onSubmit={createOrUpdate}
                            initialValues={initialValues}
                            enableReinitialize={true}
                        >
                            {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
                                <Form noValidate onSubmit={handleSubmit}>

                                    <AppCurrencyInput
                                        isRequired={true}
                                        errors={errors}
                                        touched={touched}
                                        label='Valor'
                                        value={values.value}
                                        onChange={(_, value) => setValue(value)} />

                                    <div className="commando-form-service-date" style={{ marginBottom: '20px' }}>
                                        <CalendarInput
                                            selectionMode="single"
                                            setDates={setStartDate}
                                            changeDates={handleChangeDate}
                                            values={startDate} />
                                    </div>


                                    <AppTextAreaInput errors={errors}
                                        touched={touched}
                                        name='description'
                                        onChange={handleChange}
                                        value={values.description}
                                        type='text'
                                        label='Descrição' />

                                    {isLoading ? <AppLoading /> :
                                        <AppButton type="submit" width='100%' name='adicionar' />
                                    }
                                      <div style={{ marginTop: '10px' }}>
                                        <AppLinkButton name="fechar" onClick={closeShow} />
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </AppContainer>
                </Modal.Body>
            </Modal>
        </>

    );
};

export default AdvancesModal;
